import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getAvatarUrl(path: string | null | undefined) {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  // @ts-expect-error - Vite env types might not be picked up in all contexts
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:4000';
  return `${apiUrl}/uploads/${path}`;
}
